export interface AishEducationLevelLookup {
  code?: string;
  displayValue: string;
  isMoreInfoRequired?: boolean;
}
/*
No education
Grade 1-6
Grade 7-9
Grade 10-12
Canadian Adult Education Credential (CAEC), formerly GED
High school certification of achievement
High school diploma
Trades/technical/journeyman
Some college/university
Some trades/technical
College/University
Non-credential (including college preparatory and English as a second language)
*/
/*
more info required:
Trades/technical/journeyman, Some college/university, Some trades/technical,College/University)
*/
export const AishEducationLevels: { [name: string]: AishEducationLevelLookup } = {
  noEducation: { code: 'noEducation', displayValue: 'No formal education' },
  elementary: { code: 'elementary', displayValue: 'Grade 1 - 6' },
  juniorHigh: { code: 'juniorHigh', displayValue: 'Grade 7 - 9' },
  highSchool: { code: 'highSchool', displayValue: 'Grade 10 - 12' },
  ged: { code: 'ged', displayValue: 'Canadian Adult Education Credential (CAEC), formerly GED' },
  highSchoolCertificate: {
    code: 'highSchoolCertificate',
    displayValue: 'High school certification of achievement',
  },
  highSchoolDiploma: { code: 'highSchoolDiploma', displayValue: 'High school diploma' },

  tradesJourneyman: {
    code: 'tradesJourneyman',
    displayValue: 'Trades/technical/journeyman ',
    isMoreInfoRequired: true,
  },
  someCollegeUniversity: {
    code: 'someCollegeUniversity',
    displayValue: 'Some college/university',
    isMoreInfoRequired: true,
  },

  tradesTechnical: {
    code: 'tradesTechnical',
    displayValue: 'Some trades/technical',
    isMoreInfoRequired: true,
  },

  collegeUniversity: {
    code: 'collegeUniversity',
    displayValue: 'College/University',
    isMoreInfoRequired: true,
  },

  nonCredential: {
    code: 'nonCredential',
    displayValue: 'Non-credential (including college preparatory and English as a second language)',
  },
};
